import { defineMessages } from 'react-intl';

const localMessages = defineMessages({
  hasNoQuoteAlert: '还没有填写任何账号的报价或者说明信息',
});

const messages = {
  ...localMessages,
};

export default messages;
